import { FormControl, InputLabel, Select as MuiSelect } from '@material-ui/core';
import { ChangeEvent, ClassAttributes, createElement, ReactChild, ReactNode } from 'react';
import { compose, withProps, withStateHandlers } from 'recompose';

type MenuItemElement = HTMLElement & {
  value: string;
};

type Props = ClassAttributes<MenuItemElement> & {
  label: ReactNode;
  defaultValue: string;
  onChange: (e: ChangeEvent<MenuItemElement>, value: string) => void;
  className?: string;
  children: ReactChild[];
};

type InnerProps = Props & {
  name: string;
  value: string;
  onChangeSelect: () => void;
};

const Select = compose<InnerProps, Props>(
  withProps({ name: `${Math.random()}` }),
  withStateHandlers(({ defaultValue }: Props) => ({ value: defaultValue }), {
    onChangeSelect: (_, { onChange }) => (e: ChangeEvent<MenuItemElement>) => {
      const value = e.target.value;

      onChange(e, value);

      return { value };
    },
  }),
)(({ label, className, children, name, value, onChangeSelect }) => (
  <FormControl className={className}>
    <InputLabel htmlFor={`select-${name}`}>{label}</InputLabel>

    <MuiSelect
      value={value}
      onChange={onChangeSelect}
      inputProps={{
        name,
        id: `select-${name}`,
      }}
    >
      {children}
    </MuiSelect>
  </FormControl>
));

export default Select;
